import React from "react";
import "./about_mit.css";
import CommonCards from "../../../components/reuseable_comp/common_cards/CommonCards";

const AboutMIT = () => {
  const cardsData = [
       {
      logo: "/assets/images/icons/bank.webp",
      title: "73+",
      subtitle: "Institutions, Campus- based 4 Universities",
    },
    {
      logo: "/assets/images/icons/calendar.webp",
      title: "25",
      subtitle: "Glorious Years",
    },
 
    {
      logo: "/assets/images/icons/study.webp",
      title: "50,000+",
      subtitle: "Student Per Year",
    },
    {
      logo: "/assets/images/icons/students.webp",
      title: "1,50,000+",
      subtitle: "Alumni",
    },
  ];

  return (
    <>
      <div>
        <h1 className="title">About MIT Group of Institutes</h1>
        <hr />
          {/* -------- Section 1 -------- */}
      
            <div className="about-mit-top">
                <p>
                  What started with just one institute, the Maharashtra
                  Institute of Technology (MIT Pune) under the aegis of
                  Maharashtra Academy of Engineering and Educational Research
                  Pune (MAEER), has now metamorphosed into a prestigious group
                  of institutions with over 4 Universities and 15+ Vishwa shanti
                  Gurukul schools affiliated with CBSE, IB, and State boards
                  under its auspices.
                </p>   
              <div className="about-mit-image">
                <img src="/assets/images/icons/mit_logo_black.webp" alt="Institute" />
              </div>
            </div>

            <p>
              This journey of over four decades has been guided by the pursuit
              of knowledge, quality and excellence, commitment and dedication to
              the holistic growth of its students, nutriment of value and
              discipline, the quest for science and spirituality, and enrichment
              through research. MAEER believes that "The union of science and
              spirituality alone will bring harmony and peace to humanity" as
              said by Swami Vivekananda. The vision of the founders of MAEER is
              to create a "Centre of Excellence in the field of Education and
              Research."
            </p>

          <section>
            <CommonCards cards={cardsData} />

            <p className="mit-cards-intro">
              MANET Pune is an integral part of MIT Group of Institutions and
              continues to carry the legacy of MAEER forward with exceptional
              training for the maritime profession..
            </p>
          </section>
        </div>
    </>
  );
};

export default AboutMIT;
